import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Price from 'Components/Utility/Price/Price';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';

import 'Features/Bundle/components/Mystery/MysteryKeySelectionButtons.scss';

const MysteryKeySelectionButtons = ({ bundles, selectTier }) => {
  const { selectedTier } = useContext(SelectedTierContext);

  const onClick = (value) => {
    if (value !== selectedTier) {
      selectTier(value);
    }
  };

  const mysteryKeyTotals = bundles.map(bundle => bundle.displayTotal);
  const selectedTierObj = bundles.find((bundle, index) => index === selectedTier);

  return (
    <div className="MysteryKeySelectionButtons">
      <div className="product-edition-selector">
        {mysteryKeyTotals.map((mysteryTotal, tierIndex) => {
          const selected = selectedTier === tierIndex;
          return (
            <button
              aria-pressed={selected}
              className={classNames('edition-container', { active: selected })}
              key={`mystery-key-${mysteryTotal}-${bundles[tierIndex].price.amount}`}
              type="button"
              onClick={() => onClick(tierIndex)}
            >
              <div className="edition">
                <div className="edition-name">
                  <FormattedMessage
                    id="mysterykeyselectionbuttons.text"
                    defaultMessage="{count, plural, one {# Mystery Key} other {# Mystery Keys}}"
                    values={{
                      count: mysteryTotal,
                    }}
                  />
                </div>
                {selectedTierObj && (
                  <div className="prices-container">
                    <span className={classNames('current-price', { active: selected })}>
                      <Price price={bundles[tierIndex].price} />
                    </span>
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

MysteryKeySelectionButtons.propTypes = {
  bundles: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  selectTier: PropTypes.func.isRequired,
};

export default MysteryKeySelectionButtons;
